import React, { Children } from 'react';
import { motion } from 'framer-motion';
interface PageHeroProps {
  eyebrow?: string;
  headline: string;
  description?: string;
}
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: [0.16, 1, 0.3, 1]
    }
  }
};
export function PageHero({
  eyebrow,
  headline,
  description
}: PageHeroProps) {
  return <section className="bg-sure-black w-full pt-40 pb-24 md:pb-32 border-b border-white/5" data-id="element-136">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12" data-id="element-137">
        <motion.div className="max-w-4xl" variants={containerVariants} initial="hidden" animate="show" data-id="element-138">
          {eyebrow && <motion.div variants={itemVariants} className="mb-6" data-id="element-139">
              <span className="text-sure-accent text-xs md:text-sm uppercase tracking-widest font-medium" data-id="element-140">
                {eyebrow}
              </span>
            </motion.div>}

          <motion.h1 variants={itemVariants} className="text-sure-white text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.1] mb-8" data-id="element-141">
            {headline}
          </motion.h1>

          {description && <motion.p variants={itemVariants} className="text-sure-gray text-base md:text-lg font-light leading-relaxed max-w-2xl" data-id="element-142">
              {description}
            </motion.p>}
        </motion.div>
      </div>
    </section>;
}